<ul class="chart-control {{ customCssClasses.list}}" data-test-id="timeframe-controls">
    <li class="chart-control-item {{ customCssClasses.zoomOption}}"
        *ngFor="let zoomOption of zoomOptions"
        [ngClass]="{'current': zoomOption.value === zoom}"
        [attr.data-test-id]="'timeframe-' + zoomOption.label">
        <a href="javascript:void(0)" class="chart-control-link {{ customCssClasses.zoomOptionLink }}"
           (click)="select($event, zoomOption)"
           ycnDisabled [disabled]="!zoomOption.enabled"
           [ngClass]="{'text-gray-60': !zoomOption.enabled}">
            {{ zoomOption.label }}
        </a>
    </li>
    @if (showResetOption) {
        <li class="chart-control-item">
            <a 
                href="javascript:void(0)"
                class="chart-control-link"
                ycnTooltip
                [tooltipPlacement]="'top'"
                [tooltipTitle]="'Reset'"
                (click)="resetZoomHandler.emit()">
                <svg ycnIcon name="icon-reset"></svg>
            </a>
        </li>
    }
</ul>
<ycn-feature-needed #featureNeededModal></ycn-feature-needed>
